import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/global.less';
import '@/i18n/i18n';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { Providers as ContextProviders } from '@/context/Providers';
import { initTheme } from '@/utils/theme';
initTheme();
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(_jsx(DndProvider, { backend: HTML5Backend, children: _jsx(ContextProviders, { children: _jsx(App, {}) }) }));
}
